import React from 'react';
import * as R from 'ramda';
import {Radio} from '@/Form/index';

const buildSelectOptions = options =>
  R.map(([val, txt]) => (
    <option value={val} key={val}>
      {txt}
    </option>
  ))(options);

const buildMultiSelectOptions = options =>
  R.map(([val, txt]) => ({value: val, label: txt}))(options);

const buildRadioOptions = (options, defaultVal) =>
  R.map(([val, txt]) => (
    <Radio
      inline
      key={val}
      id={val}
      value={val}
      label={txt}
      checked={val === defaultVal}
    />
  ))(options);

export {buildSelectOptions, buildMultiSelectOptions, buildRadioOptions};
